import React, { useState } from 'react';
import KardexEstAdmision from '../kardex/KardexEstAdmision';
import KardexEstMatriculacion from '../kardex/KardexEstMatriculacion';

/**
 * JefaturaEstudiantes - Vista de estudiantes para Jefatura (solo lectura)
 * Reutiliza los componentes de Kardex pero con readOnly=true
 */
export default function JefaturaEstudiantes() {
    const [tab, setTab] = useState('preadmision');

    return (
        <div className="p-4 md:p-6 max-w-7xl mx-auto">
            {/* Header */}
            <div className="mb-6">
                <h1 className="text-2xl font-bold text-gray-800">Estudiantes</h1>
                <p className="text-sm text-gray-600 mt-1">Jefatura de Carrera &gt; Estudiantes</p>
            </div>

            {/* Tabs */}
            <div className="mb-4 flex gap-2">
                <button
                    onClick={() => setTab('preadmision')}
                    className={`px-4 py-2 rounded-full font-medium transition-colors ${tab === 'preadmision'
                            ? 'bg-blue-900 text-white'
                            : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                        }`}
                >
                    Preadmisión
                </button>
                <button
                    onClick={() => setTab('matriculacion')}
                    className={`px-4 py-2 rounded-full font-medium transition-colors ${tab === 'matriculacion'
                            ? 'bg-blue-900 text-white'
                            : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                        }`}
                >
                    Matriculación
                </button>
            </div>

            {/* Content */}
            <div className="bg-white rounded-lg shadow overflow-hidden">
                {tab === 'preadmision' ? (
                    <KardexEstAdmision readOnly={true} />
                ) : (
                    <KardexEstMatriculacion readOnly={true} />
                )}
            </div>
        </div>
    );
}
